module.exports = __webpack_public_path__ + "static/media/bus-icon-map.e327514a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/regscoaches/bus-icon-map.svg
// module id = 833
// module chunks = 0